import LocationAutocomplete from '../LocationAutocomplete';
import { t } from '../../utils/i18n';

export default function HeroSearch({
  searchMode,
  onSearchModeChange,
  searchQuery,
  onSearchQueryChange,
  onLocationSelect,
  onSearch,
  locationAutocompleteRef,
}) {
  return (
    <div className="landing-search-panel">
      <form onSubmit={onSearch}>
        <div className="landing-search-tabs" role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={searchMode === 'parent'}
            onClick={() => onSearchModeChange('parent')}
            className={`landing-search-tab ${searchMode === 'parent' ? 'landing-search-tab--on' : ''}`}
          >
            {t('landing.search.findSitter')}
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={searchMode === 'sitter'}
            onClick={() => onSearchModeChange('sitter')}
            className={`landing-search-tab ${searchMode === 'sitter' ? 'landing-search-tab--on' : ''}`}
          >
            {t('landing.search.findJob')}
          </button>
        </div>

        <div className="landing-search-body">
          <div className="landing-search-row">
            <div className="landing-search-field">
              <LocationAutocomplete
                ref={locationAutocompleteRef}
                value={searchQuery}
                onChange={onSearchQueryChange}
                onSelect={onLocationSelect}
                placeholder={t('landing.search.placeholder')}
                className="w-full"
                variant="landing"
                debounceMs={300}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    locationAutocompleteRef.current?.closeDropdown();
                    onSearch(e);
                  }
                }}
              />
            </div>
            <button
              type="submit"
              onClick={() => locationAutocompleteRef.current?.closeDropdown()}
              className="landing-search-submit focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--lp-accent)] focus-visible:ring-offset-2"
            >
              {searchMode === 'parent'
                ? t('landing.search.submitSitter')
                : t('landing.search.submitJob')}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
